import { lazy, Suspense, FC } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

// types
import { BuyerChatRespVariantLazy_viewer as Viewer } from './__generated__/BuyerChatRespVariantLazy_viewer.graphql';

const LazyComponent = lazy(
    () => import(/* webpackChunkName: "BuyerChatRespVariant" */ './BuyerChatRespVariant')
);

type Props = {
    viewer: Viewer;
    isInitiallyMinimized: boolean;
    draftedMessage?: string | null;
};

export const BuyerChatRespLazyComponent: FC<Props> = props =>
    props.viewer ? (
        <Suspense fallback="">
            <LazyComponent {...props} />
        </Suspense>
    ) : null;

export const BuyerChatRespVariantLazy = createFragmentContainer(BuyerChatRespLazyComponent, {
    viewer: graphql`
        fragment BuyerChatRespVariantLazy_viewer on Viewer {
            ...BuyerChatRespVariant_viewer
        }
    `,
});
